import { Grid, Typography } from "@mui/material";
import React from "react";
import "../../PlanimetriaIcons.css";
import "../../../../index.css";
import CheckIfShowDayOnSubMenu from "../../../../functions/MostraMappa.js/InfoSubMenu/CheckIfShowDayOnSubMenu";
import AvatarImage from "../../../Avatar/AvatarImage";
import { t } from "i18next";
import { truncateString } from "../../../../functions/Utils/truncateString";
import { RISERVATA } from "../../../../const/Planimetria/StatoPostazione";
import { useSelector } from "react-redux";

export default function ShowSubMenuInfo({ info, stato, dataSelected }) {
  const infoPrenotazioneStepper = useSelector((state) => state.prenotazioneStepper);
  const configurations = useSelector((state) => state.configurations);
  const abilitaPrenotazioneMultiplaSalaRiunioni = configurations.configurazioniPrenotazione.abilitaPrenotazioneMultiplaSalaRiunioni;
  const { prenotazioni, posto } = info;

  //ORDINAMENTO PRENOTAZIONI PER DATA
  let prenotazioniOrdinateData = prenotazioni.reduce(function (r, prenotazione) {
    r.push(prenotazione);
    return r;
  }, []).sort((a, b) =>
    Date.parse(a.dataInizioPrenotazione) - Date.parse(b.dataInizioPrenotazione)
  );

  return (
    <>
      {posto && (
        <Grid
          item
          xs={12}
          sx={{
            backgroundColor: "#3e6bb4",
            color: "#F9F9FA",
            padding: "2px 5px 2px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography className="header-submenu-planimetriaInfo" sx={{ textAlign: "center", width: "100%" }}>
            <b>
              {t("workstation") + " " + posto}
            </b>
          </Typography>
        </Grid>
      )}
      <Grid
        container
        item
        xs={12}
        className="flex-center-center containerSubmenu"
      >
        {prenotazioniOrdinateData.length > 0 ? (
          prenotazioniOrdinateData.map((prenotazione, index) => {

            const {
              utentePrenotatoFullname,
              dataInizioPrenotazione,
              dataFinePrenotazione,
              immagineAvatar,
              ospite,
              nominativoOspite,
              titoloRiunione
            } = prenotazione;

            const isShowDay = CheckIfShowDayOnSubMenu(
              dataSelected,
              dataInizioPrenotazione,
              dataFinePrenotazione
            );

            return (
              <React.Fragment key={index}>
                <Grid container className="submenu-separatore">
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginX: "8px",
                      paddingLeft: "3px",
                      paddingRight: "3px",
                    }}
                  >
                    {ospite ? (
                      <AvatarImage
                        name={nominativoOspite}
                        isInputDisabled={true}
                        isCentered={false}
                        isUserLoggedImage={false}
                      ></AvatarImage>
                    ) : (
                      <AvatarImage
                        name={utentePrenotatoFullname}
                        isInputDisabled={true}
                        ImmagineAvatar={immagineAvatar}
                        isCentered={false}
                        isUserLoggedImage={false}
                      ></AvatarImage>
                    )}
                  </div>
                  <Grid>
                    <Grid
                      item xs={12} sm={12} md={12} lg={12} xl={12}
                      sx={{ display: "Flex", alignItems: "center", justifyContent: "left", paddingLeft: "5px" }}
                    >
                      <Typography sx={{ paddingTop: "5px", paddingBottom: "0px" }}>
                        <b>
                          {ospite
                            ? <>{nominativoOspite + " (" + utentePrenotatoFullname + ")"}</>
                            : utentePrenotatoFullname
                              ? utentePrenotatoFullname
                              : t("Not_available")}
                        </b>
                      </Typography>
                    </Grid>
                    <Grid
                      item xs={12} sm={12} md={12} lg={12} xl={12}
                      sx={{ display: "Flex", alignItems: "center", justifyContent: "left", paddingBottom: info.isSalaRiunione ? "0px" : "5px", paddingLeft: "5px" }}
                    >
                      <span>{isShowDay}</span>
                    </Grid>
                    {info.isSalaRiunione && (
                      <Grid
                        item xs={12}
                        sx={{ display: "Flex", alignItems: "center", justifyContent: "left", paddingBottom: "5px", paddingLeft: "5px", fontSize: 14, fontWeight: 100 }}
                      >
                        {titoloRiunione ? truncateString(titoloRiunione, 35) : ""}
                      </Grid>
                    )}
                  </Grid>
                </Grid>
              </React.Fragment>
            );
          })
        ) : (prenotazioni.length !== 0 ?
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ paddingTop: "5px", paddingBottom: "5px", paddingLeft: "5px" }}>
            <Typography className="header-submenu-planimetriaInfo"><i>{t("reserved")}</i></Typography>
          </Grid>
          :
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ paddingTop: "5px", paddingBottom: "5px", paddingLeft: "5px" }}>
            <Typography className="header-submenu-planimetriaInfo">
              <i>
                {info.isSalaRiunione && infoPrenotazioneStepper?.ripetizioneStatus && !infoPrenotazioneStepper?.id && !abilitaPrenotazioneMultiplaSalaRiunioni
                  ? t("meeting_room_not_available")
                  : stato === RISERVATA
                    ? t("reserved")
                    : t("Available")}
              </i>
            </Typography>
          </Grid>
        )}
      </Grid>
    </>
  );
}